package studio.goodegg.capsule.ui.components

import coil3.request.ImageRequest

actual fun ImageRequest.Builder.allowHardware(enable: Boolean): ImageRequest.Builder = this